import React, { useEffect, useState } from 'react';
import useHttp from '../../../../hooks/use-http';
import { urls } from './api/urls';
import GridProvider from './components/GridProvider';
import MuiDialog from '../../../UI/MuiDialog/MuiDialog';
import { formatDateFromDB } from '../../../../../utils/FormatDate';

const OpisRadova = ({ idRn }) => {
  const { getData, isLoading } = useHttp('');
  const [dnevnikArr, setdnevnikArr] = useState([]);
  const [openDialogNapomena, setOpenDialogNapomena] = useState(false);
  const [napomena, setNapomena] = useState({});

  const handleGetDnevnik = async () => {
    const config = {
      method: 'POST',
      url: urls.GET_DNEVNIK,
      data: { idDokRn: idRn },
    };
    const result = await getData(config);
    setdnevnikArr(result);
    console.log(result);
  };

  useEffect(() => {
    handleGetDnevnik();
  }, [idRn]);

  const handleClickNapomena = (item) => {
    setOpenDialogNapomena(true);
    setNapomena(item);
  };
  return (
    <div>
      <GridProvider
        data={dnevnikArr}
        isLoading={isLoading}
        handleClickNapomena={handleClickNapomena}
      />
      <MuiDialog
        maxWidth="xl"
        open={openDialogNapomena}
        title="Napomena"
        content={
          <div>
            <div style={{ marginBottom: '10px', textDecoration: 'underline' }}>
              {napomena.zaposleni} {formatDateFromDB(napomena.datumUnosa)}
            </div>
            <div style={{ whiteSpace: 'pre-wrap' }}>{napomena.opisRadova}</div>
          </div>
        }
        handleClose={() => setOpenDialogNapomena(false)}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default OpisRadova;
